export const BASE_RATE_MAPPING = {
  'n-serve': {
    'fall/early spring': 32,
    spring: 32,
    early_sidedress: 32,
    late_sidedress: 32,
  },
  instinct: {
    'fall/early spring': 37,
    spring: 37,
    early_sidedress: 37,
    late_sidedress: 37,
  },
  'instinct-nxtgen': {
    'fall/early spring': 24,
    spring: 24,
    early_sidedress: 24,
    late_sidedress: 24,
  },
  centuro: {
    'fall/early spring': 52,
    spring: 39,
    early_sidedress: 39,
    late_sidedress: 36,
  },
  function: {
    'fall/early spring': 32,
    spring: 32,
    early_sidedress: 32,
    late_sidedress: 32,
  },
  'guardian-l': {
    'fall/early spring': 70,
    spring: 60,
    early_sidedress: 48,
    late_sidedress: 48,
  },
  trident: {
    spring: 9,
    early_sidedress: 9,
    late_sidedress: 9,
  },
};

export const MAX_ADJUSTMENT_FACTOR = {
  'n-serve': 2,
  instinct: 2,
  'instinct-nxtgen': 2,
  centuro: 3,
  function: 2,
  'guardian-l': 2,
  trident: 2,
};
